import PublicLayout from './PublicLayout';
import useFetch from './useFetch';
import { getPublic } from './api';

export default function RatesPage() {
  const { data, loading, error } = useFetch(() => getPublic('/rates'), []);

  return (
    <PublicLayout
      title="Game Rates"
      description="Current game rates for Single Digit, Jodi, Single, Double and Triple Panna, Half and Full Sangam."
    >
      <div className="wrap page">
        <span className="eyebrow">Game Rates</span>
        <h1>Game rates</h1>
        <p className="lede">What each game type pays. Rates are set by the admin and shown in the app before you place a bid.</p>

        {loading && <div className="grid g3">{[0,1,2,3,4,5].map((i) => <div key={i} className="skel" />)}</div>}
        {error && <div className="card empty">{error}</div>}
        {!loading && !error && data.length === 0 && <div className="card empty">No rates configured yet.</div>}

        {!loading && !error && data.length > 0 && (
          <>
            <div className="grid g3" style={{ marginBottom: 26 }}>
              {data.map((r) => (
                <div key={r.game_type} className="card mkt">
                  <div className="top">
                    <span className="nm">{r.game_type}</span>
                  </div>
                  <div className="num">
                    {r.bid_points} <span style={{ color: 'var(--muted)', fontSize: 16 }}>→</span>{' '}
                    {Number(r.winning_points).toLocaleString('en-IN')}
                  </div>
                  <div className="tm">
                    <span>Bid {r.bid_points}</span>
                    <span>Win {Number(r.winning_points).toLocaleString('en-IN')}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="tbl-wrap">
              <table>
                <thead><tr><th>Game type</th><th>Bid points</th><th>Winning points</th></tr></thead>
                <tbody>
                  {data.map((r) => (
                    <tr key={`row-${r.game_type}`}>
                      <td data-label="Game type" style={{ fontWeight: 700 }}>{r.game_type}</td>
                      <td data-label="Bid">{r.bid_points}</td>
                      <td data-label="Wins" className="win">{Number(r.winning_points).toLocaleString('en-IN')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </PublicLayout>
  );
}
